import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders ,HttpParams} from '@angular/common/http';
import { environment } from "../../environments/environment"
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class DataSecurityService {

  constructor(private http : HttpClient) {}


  Encryptorlist() {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.post( environment.API_URL+"/api/crypto/vcryptors" ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }



  saveEncryptor(result:any) {
   
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/crypto/vcryptor",result,{headers : headers,observe:"response"});
   }
   updateStatus(result:any) {
   
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/crypto/changestatus",result,{headers : headers,observe:"response"});
   }
   updatedefault(result:any) {
   
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/crypto/changedefault",result,{headers : headers,observe:"response"});
   }
}
